import { AddFilled24 } from '@carbon/icons-react';
import { Button } from 'carbon-components-react';
import classNames from 'classnames';
import { FC, HTMLProps } from 'react';

import classes from './PopoverOpenButton.module.scss';

interface Props extends Pick<HTMLProps<HTMLButtonElement>, 'onClick'> {
  description: string;
  isHidden: boolean;
}

const PopoverOpenButton: FC<Props> = ({ description, isHidden, onClick }) => (
  <Button
    type="button"
    className={classNames(classes.button, { [classes.button_hidden]: isHidden })}
    hasIconOnly
    onClick={onClick}
    renderIcon={AddFilled24}
    size="md"
    iconDescription={description}
  >
    <div className={classes.buttonBackground} />
    <div className={classes.buttonRing} />
  </Button>
);

export default PopoverOpenButton;
